import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { ObOrderSet } from '@type/antenatal.type'
import { loadOrderSets, persistOrderSet } from '../pages/Antatal/api/orderSetStore'
import { getError, showToast } from '@util'

export function useObOrderSets() {
  const queryClient = useQueryClient()
  const query = useQuery({
    queryKey: ['anc', 'order_sets'],
    queryFn: loadOrderSets
  })

  const save = useMutation({
    mutationFn: (set: ObOrderSet) => persistOrderSet(set),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['anc', 'order_sets'] })
      showToast('Order set saved')
    },
    onError: getError
  })

  return {
    sets: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    saveSet: save.mutateAsync,
    saving: save.isPending
  }
}
